const errorMessages = {
  firstName: 'Enter a valid first name. Some special and foreign characters are not allowed.',
  lastName: 'Enter a valid last name. Some special and foreign characters are not allowed.',
  nickName:
    'Enter a valid nickname between 2 and 35 characters and containing only letters, hyphens, apostrophes, and spaces.',
  email: {
    format: 'The email address you entered is not a valid email format. Please try again.',
    taken: 'Looks like you have an Availity account. Click "Log In" to continue.',
    blacklisted: 'This email domain cannot be accepted. Enter a new email address.',
  },
  userId: {
    format: 'Enter a valid alphanumeric ID from 6 to 15 characters in length.',
    taken:
      'This User ID is already taken. Already have an Availity account with this User ID? Click "Log In" to continue.',
  },
  password: {
    valid: 'Enter a valid password.',
    repeatingChars: 'Your password cannot have more than 2 of the same characters consecutively.',
  },
  region: 'Select a U.S. state or territory from the drop-down menu.',
  securityQuestion: {
    valid: 'Double-check to ensure you have selected three different security questions.',
    answer:
      "Your security question answer must contain 2 characters and no more than 130 characters. In addition, Your answer may only contain letters, numbers, spaces, !, ., ?, -, '.",
    answerForbiddenWords: "Your security question answer may not contain your user ID or the word 'password'.",
    duplicate: 'This question has already been selected. Please select another question.',
    answerDuplicate: 'Double-check to ensure you have provided a unique answer for all three security questions.',
  },
};

export default errorMessages;
